<div class="product-item">
    <div class="image" (click)="triggerView()">
        <div class="new-overlay" *ngIf="product?.new?.value == 1" i18n="@@product-card_new-product">New</div>
        <div *ngIf="hasThumbnail"
             [style.background-image]="'url(' + product?.thumbnailUrl +')'"></div>
        <div *ngIf="!hasThumbnail"
             [style.background-image]="'url(./assets/images/placeholder.png)'"></div>
    </div>
    <div class="description">
        <div class="decor" *ngIf="product.decor != null">{{product.decor.label}}</div>
        <div class="decor" *ngIf="product.decor == null">{{decorDefaultName}}</div>
        <div class="name">{{product?.name}}</div>
        <div class="price">{{product.price | currency : this.storeService.getStoreCurrency()}}*</div>
    </div>
    <div class="actions">
        <button class="btn-primary" [disabled]="isLoading" (click)="triggerAddToQuote()"
                i18n="@@product-card_add-to-quote-button">Add to quote
        </button>
    </div>
</div>
